import React, { type ReactNode } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { type ButtonProps } from '@atlaskit/button';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { usePullRequestTableOptionsStore } from '../../../../../../../../../controllers/pull-request-filters';

export interface ClearFiltersButtonProps extends Omit<ButtonProps, 'type'> {
	children?: ReactNode;
	testId: string;
}

const ClearFiltersButton = ({ children, ...props }: ClearFiltersButtonProps) => {
	const [, { resetFilters }] = usePullRequestTableOptionsStore();

	const handleOnClick = (event: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
		resetFilters();
		fireUIAnalytics(analyticsEvent, 'pullRequestTableClearFilters');
	};

	return (
		<Button {...props} onClick={handleOnClick}>
			{children}
		</Button>
	);
};

export default ClearFiltersButton;
